import React from "react"
import PropTypes from "prop-types"
import Hr from "@irati/ui/src/Layout/Hr"
import {H3} from "@irati/ui/src/Typography/Heading"
import {FormattedMessage} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {List, Item, ItemContent, ItemIcon} from "../styled/List"
import {SkipForNow, NextStep, ButtonsWrapper} from "../styled/Buttons"
import {SlideWrapper} from "../styled/Slider"
import iconTrophy from "../../../images/onboarding/trophy.svg"
import iconReward from "../../../images/onboarding/reward.svg"
import iconComment from "../../../images/onboarding/comment.svg"

const Step2 = ({onNext, onSkip}) => {
  const tenant = authentication.userTenant()
  const step2Text = authentication.apps("recognition.poll.create")
    ? "recognition.onboarding.step2.item.trophy"
    : "recognition.onboarding.step2.item.voteInPolls"
  return (
    <SlideWrapper>
      <header>
        <H3 className="text-center">
          <FormattedMessage id="recognition.onboarding.step2.header" values={{tenantName: tenant.public_name}} />
        </H3>
        <Hr />
      </header>
      <List>
        <Item>
          <ItemIcon src={iconComment} alt="Comments" />
          <ItemContent>
            <FormattedMessage id="recognition.onboarding.step2.item.comments" />
          </ItemContent>
        </Item>
        <Item>
          <ItemIcon src={iconTrophy} alt="Trophy" />
          <ItemContent>
            <FormattedMessage id={step2Text} />
          </ItemContent>
        </Item>
        <Item>
          <ItemIcon src={iconReward} alt="Rewards" />
          <ItemContent>
            <FormattedMessage id="recognition.onboarding.step2.item.rewards" />
          </ItemContent>
        </Item>
      </List>
      <ButtonsWrapper>
        <Hr />
        <NextStep onClick={onNext} />
        <SkipForNow onClick={onSkip} />
      </ButtonsWrapper>
    </SlideWrapper>
  )
}

Step2.propTypes = {
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired
}

export default Step2
